// Ошибка изменения, показанная человеку конвертом сервера: что произошло, почему и что
// сделать. Одна на все формы приложения.
//
// Своя плашка в каждой форме — это восемь мест, где кто-нибудь однажды покажет
// «что-то пошло не так»: по правилу 10 такой текст ошибкой не считается, потому что не
// называет ни причины, ни шага. Здесь конверт разбирается один раз и целиком.

import type { ReactNode } from 'react';

import { RiErrorWarningLine } from '@remixicon/react';

import { ApiError } from '@/shared/errors/api-error';
import * as Alert from '@/shared/ui/alert';

export function ErrorAlert({
  error,
  className,
  action,
}: {
  error: unknown;
  className?: string;
  /** Кнопка следующего шага, если он есть: «Повторить». Стоит внутри конверта, а не рядом. */
  action?: ReactNode;
}) {
  // ⚠️ Не всякая ошибка приходит конвертом сервера. Сбой в самом браузере (опечатка в коде,
  // недоступный API) доезжает сюда обычным Error, и разбор конверта на нём падал — а падение
  // ВНУТРИ показа ошибки роняет весь экран в «Unexpected Application Error». То есть ровно там,
  // где человеку нужно объяснение, он получал белый лист. Поймано тестом экрана табеля.
  const { message, hint, next_action } = конверт(error);
  return (
    <Alert.Root variant='light' status='error' size='small' role='alert' className={className}>
      <Alert.Icon as={RiErrorWarningLine} />
      <div className='flex min-w-0 flex-col gap-0.5'>
        <span>{message}</span>
        {hint !== undefined && <span className='text-paragraph-xs opacity-80'>{hint}</span>}
        {next_action !== undefined && (
          <span className='text-paragraph-xs opacity-80'>{next_action}</span>
        )}
        {action !== undefined && <div className='mt-1 flex items-center gap-2'>{action}</div>}
      </div>
    </Alert.Root>
  );
}

/** Конверт из чего угодно: сбой браузера тоже обязан объяснить себя человеку. */
function конверт(error: unknown): { message: string; hint?: string; next_action?: string } {
  if (ApiError.is(error)) {
    return error.envelope;
  }
  return {
    message: 'Сбой в программе',
    hint: error instanceof Error ? error.message : String(error),
    next_action: 'Обновите страницу; если повторится — сообщите администратору',
  };
}
